<template>
    <status :is-test-mode="isTestModeComputed"
            :view-only="viewOnlyComputed"
            :show-banner-tooltip="showBannerTooltipComputed"
            @changed="exportChange"
    ></status>
</template>

<script>
import externalPropsParser from 'services/utils/externalPropsParser';
import Status from 'monetize/adUnitSettings/Status.vue';
import eventBus from '@/mixins/eventBus';
import externalParsedProps from '@/mixins/externalParsedProps';

const parsedProps = ['isTestMode', 'viewOnly', 'showBannerTooltip'];

export default {
    name: 'AdUnitSettingsStatusEx',
    mixins: [
        eventBus('ad-unit-settings-status'),
        externalParsedProps(Status.props, parsedProps)
    ],
    props: externalPropsParser.setExternalProps(Status.props, parsedProps),
    methods: {
        exportChange(data) {
            this.$emit('changed', data);
        }
    },
    components: { Status }
};
</script>
